import {useQuery} from 'react-query';
import { useMemo } from 'react';
import {Settings} from '../Settings';
import {client} from "./ApiClient";
import {useCustomLoyaltyEngineUrl} from './Contexts/ServiceUrlsOverrideContext.jsx';

const getServiceUrls = (key, domain) => client(Settings.DomainServerUrl, 'api/v4/serviceurls/' + domain);

export default function useServiceUrls(domain) {
    const customLoyaltyEngineUrl = useCustomLoyaltyEngineUrl();
    const shouldFetch = !!domain && !customLoyaltyEngineUrl;

    const { status, data, error, isFetching } = useQuery(['ServiceUrls', domain], (key) => getServiceUrls(key, domain), {
        enabled: shouldFetch,
        staleTime: 1000*60*30
    });

    const serviceUrlsStatus = customLoyaltyEngineUrl ? 'success' : status;
    const serviceUrls = useMemo(() => {
        if (customLoyaltyEngineUrl) {
            return { LoyaltyEngineApiUrl: customLoyaltyEngineUrl };
        }
        return data ? data.data : undefined;
    }, [customLoyaltyEngineUrl, data]);
    const serviceUrlsError = customLoyaltyEngineUrl ? undefined : error;
    const isServiceUrlsFetching = customLoyaltyEngineUrl ? false : isFetching;
    return {serviceUrlsStatus, serviceUrls, serviceUrlsError, isServiceUrlsFetching}
}